import { foot, type WorldObject } from './mapdef';

/** Interactive objects of the life package (ids prefixed, see mapdef ObjectId). */
export const OBJECTS_LIFE: readonly WorldObject[] = [
  // Your bedroom, by the study desk.
  { id: 'life_piggy', map: 'home', rect: foot(17, 5, 1, 7), solid: true, label: 'life_piggy', icon: '🐷', tall: 14 },
  // Lantern Mall atrium: the fast-food counter and a flashy ad screen.
  { id: 'life_fastfood', map: 'mall', rect: foot(1, 12, 5, 12), solid: true, label: 'life_fastfood', icon: '🍔', tall: 34 },
  { id: 'life_adscreen', map: 'mall', rect: foot(36, 12, 3, 8), solid: true, label: 'life_adscreen', icon: '📺', tall: 36 },
];
